// src/managerPortal/components/common/EditButton.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import "../../styles/Buttons.css";

const EditButton = ({ onClick }) => {
    return (
        <button onClick={onClick} className="btn-icon btn-edit" title="Edit">
            <FontAwesomeIcon icon={faPen} />
        </button>
    );
};

export default EditButton;
